import React, {Component} from 'react';
import PropTypes from "prop-types";
import CurlContainer from "../../utils/CurlContainer";
import WindowDimensions from "../../utils/WindowDimensions";

class AcademyContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.removeElements = [
            'link[rel="icon"]',
            'header#header',
            'div#navigation',
            'div#action-messages',
            'a.assistive',
            'div#page-metadata-start',
            'div#page-metadata-end',
            'div.page-metadata',
            'div.ia-splitter-left',
            'div#title-heading',
            '#labels-section',
            //'.update-item-date',
            '.update-item-changes'
        ];

        this.translate = this.props.baseData.translate;

    }

    render() {

        const url = 'https://faq.zsk.de/x/A4AZ';    //  https://faq.zsk.de
        const containerHeight = WindowDimensions.getWindowDimensions('contentAreaHeight');

        return (
            <CurlContainer
                id="academyTraining"
                baseData={this.props.baseData}
                url={url}
                removeElements={this.removeElements}
                style={{'height': containerHeight + 'px'}}
            />
        );

    }

}

export default AcademyContainer;